import requests from '@/utils/request.js'

export const getUserInfoAPI = (data) => requests({
  method:'POST',
  url:'/api/login',
  data
})

export const getUserInfo = (data) => requests({
  method:'POST',
  url:'/api/user/get_user_info',
  data
})



